export enum OrderType {
  FINAL_INSTALMENT_TOTAL = 'FINAL_INSTALMENT_TOTAL', //simulationSummary.finalInstallment.CAPITAL_AND_INTEREST
  INTEREST_RATE = 'INTEREST_RATE', //simulation.interestRate.rates
  TOTAL_COST = 'TOTAL_COST', //simulationSummary.totalCosts.TOTAL
  COMMISSION = 'COMMISSION', //simulationSummary.totalCosts.COMMISSION
}
